import HostnameProvider from '~/interfaces/HostnameProvider';
import Configuration from './Configuration';

export const EXPERIENCE_NAME_CLIENTS = 'iA My Client Space';

export function escapeWhiteSpaces(url: string): string {
  if (url) return url.replace(/\s/g, '%20');
  return url;
}

export function processMockedPath(mockedPath: string, unmockedPath: string): string {
  const path = Configuration.Current().mockingEnabled === true ? mockedPath : unmockedPath;
  return escapeWhiteSpaces(path);
}

export function getHomePageUrl(): string {
  return processMockedPath('/', '/log-off');
}

function GetDefaultHostnameProvider(): HostnameProvider {
  return {
    GetHostname: () => window.location.hostname,
  };
}

export function isLocalhost(hostnameProvider?: HostnameProvider): boolean {
  const provider = hostnameProvider || GetDefaultHostnameProvider();
  const host = provider.GetHostname();
  return !host || host === 'localhost' || host === '127.0.0.1';
}
